/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
// import React from 'react'
import { Grid } from "@material-ui/core";
import { AnnounceTextFieldNumber } from "../../../Announces/components/AnnounceTextFieldNumber";
import {
    AnnounceInputs,
    IAddress,
    IProperty,
    PropertyInputs,
} from "../../../../utils/AnnounceInterfaces";
import { makeStyles, Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
// import AnnounceSelect from '../../../Announces/components/AnnounceSelect';
// import AnnounceSwitch from '../../../Announces/components/AnnounceSwitch';
import { AnnounceTextFieldMultine } from "../../../Announces/components/AnnounceTextFieldMultine";
import React, { useEffect } from "react";
import { PropertyService } from "../../services/PropertyService";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        announcePriceContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
        },
        announceCleaningPriceContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            marginTop: 16,
        },
        announcePriceItem: {
            flex: 0.47,
        },
        inpuText: {
            marginBottom: 14,
            marginTop: 6,
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        inputContent: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginTop: 16,
            display: "block",
            marginBottom: 16,
        },
        finalPrice: {
            marginTop: 16,
            display: "block",
            background: "#890608",
            padding: 16,
            color: "white",
            borderRadius: 3,
            width: 200,
        },
        containerLabel: {
            textAlign: "left",
        },
        platformFees: {
            width: "100%",
            background: "#f8efc92f",
            padding: 16,
        },
    })
);

const propertyService = new PropertyService();
export const StepFive = (props: {
    values: AnnounceInputs;
    propertyTypeValues: any;
    address: IAddress;
    devise: string;
    priceWeeklyDaily: number;
    priceBiWeeklyDaily: number;
    priceMonthlyDaily: number;
    handleChange: (e: any) => void;
    handleChangeSpecialPrice: (e: any) => void;
    handleSuperOffer: (e: any) => void;
    searchTypeName?: string;
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const SearchTypeName = props.searchTypeName;
    const [commissionFee, setCommissionFee] = React.useState<number>(0);
    useEffect(() => {
        if (props.propertyTypeValues.name === "Hôtel") {
            propertyService
                .getSpecialFeeByPropertyType(props.propertyTypeValues.name)
                .then((response) => {
                    if (response.success) {
                        setCommissionFee(
                            response.data?.percentageTraveller || 0
                        );
                    }
                })
                .catch((error) => console.log(error));
        } else {
            propertyService
                .getHostFeeByCountryAndCityId(
                    props.address.country?.name || "", 
                    props.address.city?.name  || "", 
                )
                .then((respCom) => {
                    if (respCom.success) {
                        setCommissionFee(respCom.data?.percentage || 0);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, []);

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <div>

            {
                SearchTypeName === "cars" ? (
                    <>
                        <Grid container style={{ textAlign: "left" }} spacing={2}>
                            <AnnounceTextFieldMultine
                                id="announceDescription"
                                label="Description *:"
                                name="description"
                                value={props.values.description}
                                handleChange={props.handleChange}
                            />
                            <Grid item xs={12} lg={12}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"announcePrice"}
                                        label={`${t("annonce.labels.tarif-journalier")} (${
                                            props.devise
                                        }) *:`}
                                        name="price"
                                        value={
                                            props.values.price === 0
                                                ? ""
                                                : props.values.price
                                        }
                                        handleChange={props.handleChange}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"announcePriceOutOfCity"}
                                        label={`${t(
                                            "annonce.labels.tarif-hors-ville"
                                        )} (${props.devise}) :`}
                                        name="priceOutOfCity"
                                        value={
                                            props.values.priceOutOfCity === 0
                                                ? ""
                                                : props.values.priceOutOfCity
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <div className={classes.platformFees}>
                                <Grid
                                    item
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                    className={classes.containerLabel}
                                >
                                    <label
                                        htmlFor="CommissionId"
                                        className={classes.inputContent}
                                    >
                                        {t("label.commission-de-la-plateforme")}{" "}
                                        {commissionFee} %
                                    </label>
                                </Grid>
                            </div>
                        </Grid> 
                    </>  
                    ) : (
                    <>     
                        <Grid container style={{ textAlign: "left" }} spacing={2}>
                            <AnnounceTextFieldMultine
                                id="announceDescription"
                                label="Description *:"
                                name="description"
                                value={props.values.description}
                                handleChange={props.handleChange}
                            />

                            <Grid item xs={12} lg={12}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"announcePrice"}
                                        label={`${t(SearchTypeName === "trs" ? "annonce.labels.tarif-de-la-prestation" : "annonce.labels.tarif-journalier")} (${
                                            props.devise
                                        }) *:`}
                                        name="price"
                                        value={
                                            props.values.price === 0
                                                ? ""
                                                : props.values.price
                                        }
                                        handleChange={props.handleChange}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                    { SearchTypeName !== "rstt" && SearchTypeName !== "trs" && (
                        <>   
                            <Grid item xs={12} sm={6} lg={6}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"priceWeeklyDaily"}
                                        label={`${t(
                                            "annonce.labels.tarif-journalier-forfaitaire-pour-une-semaine"
                                        )} (${props.devise}) :`}
                                        name="priceWeeklyDaily"
                                        value={
                                            props.priceWeeklyDaily === 0
                                                ? ""
                                                : props.priceWeeklyDaily
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"announcePriceWeekly"}
                                        label={`${t(
                                            "annonce.labels.tarif-forfaitaire-pour-une-semaine"
                                        )} (${props.devise}) :`}
                                        name="priceWeekly"
                                        value={
                                            props.values.priceWeekly === 0
                                                ? ""
                                                : props.values.priceWeekly
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6} container>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"priceBiWeeklyDaily"}
                                        label={`${t(
                                            "annonce.labels.tarif-journalier-forfaitaire-pour-deux-semaines"
                                        )} (${props.devise}) :`}
                                        name="priceBiWeeklyDaily"
                                        value={
                                            props.priceBiWeeklyDaily === 0
                                                ? ""
                                                : props.priceBiWeeklyDaily
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6} container>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"announcePriceBiWeekly"}
                                        label={`${t(
                                            "annonce.labels.tarif-forfaitaire-pour-deux-semaines"
                                        )} (${props.devise}) :`}
                                        name="priceBiWeekly"
                                        value={
                                            props.values.priceBiWeekly === 0
                                                ? ""
                                                : props.values.priceBiWeekly
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"priceMonthlyDaily"}
                                        label={`${t(
                                            "annonce.labels.tarif-journalier-forfaitaire-pour-un-mois"
                                        )} (${props.devise}) :`}
                                        name="priceMonthlyDaily"
                                        value={
                                            props.priceMonthlyDaily === 0
                                                ? ""
                                                : props.priceMonthlyDaily
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={6}>
                                <div className={classes.announcePriceContainer}>
                                    <AnnounceTextFieldNumber
                                        id={"announcePriceMonthly"}
                                        label={`${t(
                                            "annonce.labels.tarif-forfaitaire-pour-un-mois"
                                        )} (${props.devise}) :`}
                                        name="priceMonthly"
                                        value={
                                            props.values.priceMonthly === 0
                                                ? ""
                                                : props.values.priceMonthly
                                        }
                                        handleChange={props.handleChangeSpecialPrice}
                                        placeholder="0"
                                    />
                                </div>
                            </Grid>
                            { SearchTypeName !== "cars" && (
                                <Grid item xs={12} lg={12}>
                                    <div className={classes.announceCleaningPriceContainer}>
                                        <AnnounceTextFieldNumber
                                            id={"announcePrice "}
                                            label={`${t("label.frais-de-nettoyage")} (${
                                                props.devise
                                            }) :`}
                                            name="cleaningFees"
                                            value={
                                                props.values.cleaningFees === 0
                                                    ? ""
                                                    : props.values.cleaningFees
                                            }
                                            handleChange={props.handleChange}
                                            placeholder="0"
                                        />
                                    </div>
                                </Grid>
                            )}   
                        </>    
                    )}
                            <div className={classes.platformFees}>
                                <Grid
                                    item
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                    className={classes.containerLabel}
                                >
                                    <label
                                        htmlFor="CommissionId"
                                        className={classes.inputContent}
                                    >
                                        {t("label.commission-de-la-plateforme")}{" "}
                                        {commissionFee} %
                                    </label>
                                </Grid>
                            </div>
                        </Grid>
                    </>
                )
            }        
        </div>
    );
};
